import Pica from "pica";

const pica = new Pica();

//* Compress image using pica
export async function compressImage(
    file,
    { maxWidth = 1600, maxHeight = 1600, quality = 0.8 } = {}
) {
    const img = document.createElement("img");
    const url = URL.createObjectURL(file);

    await new Promise((res, rej) => {
        img.onload = res;
        img.onerror = rej;
        img.src = url;
    });

    const scale = Math.min(maxWidth / img.width, maxHeight / img.height, 1);

    const canvas = document.createElement("canvas");
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);

    await pica.resize(img, canvas);

    const blob = await pica.toBlob(canvas, "image/jpeg", quality);

    URL.revokeObjectURL(url);

    return new File([blob], file.name, {
        type: "image/jpeg",
        lastModified: Date.now(),
    });
}
